// extracted by mini-css-extract-plugin
export default {"scopePicker":"DepartmentsPlanPopup_scopePicker__juB-+","error":"DepartmentsPlanPopup_error__P3vQ+"};